import React from 'react';
import Calendar from '@views/orders/Calendar';

export default function OrderDeadlineCalendar() {
    return <Calendar rowIndex={0} label="OrderForm.products.fields.order_deadline" name="deadline_at"/>;
}
